import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl'
import {
  app_icon,
  app_badge_apple,
  app_badge_google,
} from '../../../assets/imgs';

import './AppPromo.scss';

const HomeAppPromo = () => {
  const { formatMessage } = useIntl();

  return (
    <section className="app-promo">
      <div className="app-promo-wrapper">
        <div className="headline">
          <h3 dangerouslySetInnerHTML={{ __html: formatMessage({id:"app_promo.block_title", defaultMessage:"<span>Enjoy exclusive </span> <span> <em>ACUVUE® privileges </em> </span> <span>at your fingertips</span>" }) }} />

          <div className="illustration">
            <div className="app-wrapper">
              <img
                src={app_icon}
                alt="MyAcuvue mobile app icon"
                className="app-icon"
              />
              <p dangerouslySetInnerHTML={{ __html: formatMessage({id:"app_promo.acuvue", defaultMessage: "MyACUVUE®" })}}></p>
              <img
                src={app_badge_apple}
                alt="Download on the App Store"
                className="app-store-badge"
              />
              <img
                src={app_badge_google}
                alt="Get it on the Google Play"
                className="app-store-badge"
              />
            </div>
          </div>
        </div>
        <ul className="selling-points">
          <li>
            <FormattedMessage id="app_promo.li_01" defaultMessage="Enjoy exclusive offers"  />
          </li>
          <li>
            <FormattedMessage id="app_promo.li_02" defaultMessage="Earn points for every dollar spent"  />
          </li>
          <li>
            <FormattedMessage id="app_promo.li_03" defaultMessage="Redeem points for savings on your next purchase"  />
          </li>
        </ul>
        <div className="cta">
          <div className="cta-wrapper">
            <h5>
              <FormattedMessage id="app_promo.cta_title" defaultMessage="Enjoy $20 off your first purchase"  />
            </h5>

            <FormattedMessage
              id="app_promo.cta_btn"
              defaultMessage="<a>Learn More</a>"
              values={{
                a: msg => (
                  <a
                    href={formatMessage({ id: 'app_promo.cta_link' })}
                    target="_blank"
                    className="discover-btn secondary"
                  >
                    {msg}
                    <div className="new-tab btn-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 14" fill="none" overflow="visible" >
                        <path d="M12.75 1.75V5.25M12.75 1.75H9.25H12.75ZM12.75 1.75L7.5 7L12.75 1.75Z"></path>
                        <path d="M12.75 7.58333V11.0833C12.75 11.7277 12.2277 12.25 11.5833 12.25H3.41667C2.77233 12.25 2.25 11.7277 2.25 11.0833V2.91667C2.25 2.27233 2.77233 1.75 3.41667 1.75H6.91667"></path>
                      </svg>
                    </div>
                  </a>
                ),
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeAppPromo;
